<script setup>
// BonBoZ: khay ảnh chờ gửi — DẢI NGANG CUỘN thay vì lưới thẻ file.
//
// Bản gốc xếp mỗi tệp thành một thẻ rộng 15rem có tên + dung lượng, tràn thì
// xuống hàng. Gửi 10 ảnh một lúc (chuyện thường ngày khi tư vấn) là khay cao
// bốn hàng, đẩy khung gõ lên quá nửa màn hình. Tên tệp `Voucher Seo Ro 03.png`
// cũng chẳng nói gì mà chính tấm ảnh không nói rõ hơn.
//
// Dải ngang: khay cao đúng một hàng dù 3 hay 30 ảnh, người trực nhận ra ảnh
// bằng mắt. Số tệp nằm trên đầu vì cuộn ngang thì không đếm được bằng mắt.
import { computed } from 'vue';

const props = defineProps({
  attachments: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['removeAttachment']);

const nonRecordedAudioAttachments = computed(() => {
  return props.attachments.filter(attachment => !attachment?.isVoiceMessage);
});

const recordedAudioAttachments = computed(() =>
  props.attachments.filter(attachment => attachment.isVoiceMessage)
);

const onRemoveAttachment = itemIndex => {
  emit(
    'removeAttachment',
    nonRecordedAudioAttachments.value
      .filter((_, index) => index !== itemIndex)
      .concat(recordedAudioAttachments.value)
  );
};

const isTypeImage = file => {
  const type = file.content_type || file.type;
  return type.includes('image');
};

const fileName = file => file.filename || file.name;

// Video (#119): hien khung dau cua chinh tep, khong hien bieu tuong tep chung
// chung — nguoi truc can thay dung video nao sap gui.
const isTypeVideo = file =>
  (file.content_type || file.type || '').includes('video');
</script>

<template>
  <div class="flex flex-col gap-1">
    <span class="text-xs text-n-slate-11">
      {{
        $t('BONBOZ.KHAY_ANH.SO_TEP', { so: nonRecordedAudioAttachments.length })
      }}
    </span>
    <!-- Cuộn ngang, KHÔNG xuống hàng: đó là toàn bộ điểm của bản này. -->
    <div class="flex gap-1.5 overflow-x-auto pb-1">
      <div
        v-for="(attachment, index) in nonRecordedAudioAttachments"
        :key="attachment.id"
        v-tooltip.top="fileName(attachment.resource)"
        class="group relative flex-shrink-0 w-16 h-16 overflow-hidden border rounded-lg bg-n-slate-3 border-n-weak"
      >
        <img
          v-if="isTypeImage(attachment.resource)"
          class="object-cover w-full h-full"
          :src="attachment.thumb"
        />
        <video
          v-else-if="isTypeVideo(attachment.resource)"
          :src="attachment.thumb"
          preload="metadata"
          muted
          playsinline
          class="object-cover w-full h-full"
        />
        <div
          v-else
          class="flex flex-col items-center justify-center w-full h-full gap-0.5 px-1"
        >
          <span class="text-lg leading-none">📄</span>
          <span
            class="w-full text-[9px] leading-tight text-center truncate text-n-slate-11"
          >
            {{ fileName(attachment.resource) }}
          </span>
        </div>
        <span
          v-if="isTypeVideo(attachment.resource)"
          class="absolute inset-0 grid pointer-events-none place-items-center"
        >
          <span
            class="grid text-white rounded-full size-6 place-items-center bg-[rgb(0_0_0/0.55)]"
          >
            <span class="i-lucide-play size-3.5" />
          </span>
        </span>
        <!-- Nút xoá góc TRÊN PHẢI, chỉ hiện khi rê chuột vào đúng tấm đó.
             Vẽ bằng SVG chứ không dùng ký tự ✕: ký tự có baseline riêng nên
             không bao giờ nằm chính giữa vòng tròn.
             Nền viết giá trị tay `bg-[rgb(0_0_0/0.6)]`, KHÔNG dùng `bg-black/60`:
             `black` trong theme/colors.js là một dải màu không có DEFAULT nên
             `bg-black/60` không sinh CSS — nút thành chữ ✕ trắng trên nền trong
             suốt, vô hình trên ảnh sáng mà vẫn bấm trúng được.
             Cỡ SVG đặt bằng thuộc tính `width/height` + `shrink-0`: để class
             `w-2.5` thì trong nút flex nó co về rộng 0px — cao vẫn đủ, dấu ✕
             biến mất mà không báo gì. -->
        <button
          type="button"
          :aria-label="$t('BONBOZ.KHAY_ANH.XOA')"
          class="absolute flex items-center justify-center w-5 h-5 text-white transition-opacity rounded-full opacity-0 top-1 right-1 bg-[rgb(0_0_0/0.6)] hover:bg-[rgb(0_0_0/0.8)] group-hover:opacity-100 focus:opacity-100"
          @click="onRemoveAttachment(index)"
        >
          <svg
            viewBox="0 0 10 10"
            width="10"
            height="10"
            class="shrink-0"
            aria-hidden="true"
          >
            <path
              d="M1 1 L9 9 M9 1 L1 9"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              fill="none"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>
